export default {
  editShopHomepagePage: '编辑页面店铺首页',
  save: '保存数据',
  componentLibrary: '组件库',
  dragAndDropToUse: '拖拽使用',
  dropHere: '放这里',
  layer: '层',
  send: '传送',
  copy: '复制',
  delete: '删除',
  componentSettings: '组件设置',
  componentRemarks: '定位备注',
  editCoordinates: '编辑坐标',
  coordinateSelection: '坐标选择',
  pleaseSelectALocation: '请选择位置',
  pleaseSelectProduct: '请选择商品',
  atLeast2ComponentsRequiredForThematicPage: '专题页组件数量大于2才能使用',
  previous: '之前',
  cancel: '取消',
  confirm: '确定',
  pleaseCheckIfTheThematicPageIDIsCorrect: '请检查专题页的ID是否正确',
  thisActionWillPermanentlyRemoveTheComponent: '此操作将永久该组件移除, 是否继续',
  tip: '提示',
  successfullyDeleted: '删除成功',
  deletionCanceled: '已取消删除',
  onlyOneInstanceOfThisComponentCanBeAdded: '此组件只可添加一个',
  over30ComponentsCauseLag: '当前页面已添加超过30个以上组件, 会引起页面卡顿, 建议精简组件数量',
  areYouSureYouWantToCopy: '是否确定复制',
  copiedComponentPlacedAtEndByDefault: '复制后的组件默认跟在后面',
  pleaseSelectCoordinates: '请选择坐标',
  commandExecutionSuccessful: '传送命令执行成功',
  savedSuccessfullyCheckViaApp: '保存成功, 可去手机 APP 店铺首页查看最新效果',
  carouselAd: '轮播广告',
  hotSpotImage: '热切图',
  title: '标题',
  productComponent: '商品组件',
  subtitle: '副标题',
  pleaseSelect: '请选择',
  actionTypesAfterClick: '操作类型一共4种，对应点击以后的操作',
  carouselInterval: '轮播间隔',
  recommendedSize: '推荐尺寸',
  adLink: '广告链接',
  addImage: '添加图片',
  dragUpAndDownToSort: '上下拖动可排序',
  submit: '提交',
  loginSessionExpired: '用户登陆状态已失效， 请重新登陆后使用',
  imageUpload: '图片上传',
  hotspotManagement: '热区管理',
  hotspotItem: '热区项',
  hotspotAdjustPositionSize: '添加热区后单击左边的图形可拖拽位置、调整大小',
  actionType: '操作类型',
  addRectangle: '添加矩形',
  addCircle: '添加圆形',
  backgroundColor: '背景色',
  fontColor: '字体颜色',
  moreFontColor: 'more字体颜色',
  redirectAddress: '跳转地址',
  position: '位置',
  alignLeft: '左边',
  center: '中间',
  productType: '商品类型',
  onePerRow: '一行一个',
  twoPerRow: '一行两个',
  threePerRow: '一行三个',
  multiplePerRow: '一行多个',
  componentColor: '组件颜色',
  selectProduct: '选择商品',
  pinToTop: '置顶',
  outOfStock: '无库存',
  search: '搜索',
  upTo200ProductsCanBeAdded: '最多可添加200个商品',
  bulkAdd: '批量添加',
  selectedProducts: '已选商品',
  youHaveSelectedXProducts: '您已选择x个商品',
  adjustOrderOfProducts: '可调整商品排列顺序',
  productInformation: '商品信息',
  price: '价格',
  sort: '排序',
  operate: '操作',
  option1: '选项1',
  option2: '选项2',
  pleaseEnterQuantityForBulkAdding: '请填写批量添加数量',
  cannotExceed200AtMaximum: '最多不能超过200个',
  failedToRetrieveDataRetry: '获取数据失败， 请重试',
  saveError: '保存失败',
  homePageDesign: '店铺首页设计',
  storeKeywords: '店铺关键字',
  enterKeywordsToSearchForProductsInStore: '关键字类型会根据搜索关键字跳转到店铺商品搜索页面，输入框填写搜索关键字',
  urlLink: 'Url链接',
  enterCompleteURLToBeRedirected: '链接会跳转到指定链接，输入框填写完整的URL',
  enterProductListingIDToViewDetails: 'Listing Id会跳转到指定的商品详情页面，输入框填写Listing ID',
  storeCategoryID: '店铺类目ID',
  pleaseInputStoreCategoryID: '请输入店铺类目ID'
}
